import type { TFunction } from "i18next";

export function formatGeneratedTime(
  dateString: string | null,
  kind: "created" | "refreshed",
  t: TFunction<"projectHome">
) {
  if (!dateString) return null;
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return t(`presentation.${kind}.justNow`);
  if (diffMins < 60) return t(`presentation.${kind}.minutes`, { count: diffMins });
  if (diffHours < 24) {
    return t(diffHours === 1 ? `presentation.${kind}.hourOne` : `presentation.${kind}.hourMany`, { count: diffHours });
  }
  return t(diffDays === 1 ? `presentation.${kind}.dayOne` : `presentation.${kind}.dayMany`, { count: diffDays });
}
